import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col border-b-2 border-gray-200 max-h-full overflow-y-auto pl-2" }
const _hoisted_2 = { class: "grid grid-rows-1 grid-cols-5 bg-white p-4 relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, null, -1)
const _hoisted_4 = { class: "col-span-3 flex flex-col items-center justify-center text-black-700 mt-2" }
const _hoisted_5 = { class: "flex-1 flex flex-col" }
const _hoisted_6 = { class: "border-b-2 border-gray-200 pb-4 text-wrap flex flex-col" }
const _hoisted_7 = { class: "mt-4 font-semibold" }
const _hoisted_8 = { class: "w-full flex-wrap flex flex-col box-border justify-center items-center px-2 max-sm:text-left max-sm:w-full max-sm:justify-center max-sm:align-middle" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle font-light text-sm text-gray-500 max-sm:pl-5" }, " Atribuído: ", -1)
const _hoisted_10 = {
  key: 0,
  class: "w-full max-sm:mr-7 max-md:pl-11"
}
const _hoisted_11 = { class: "align-middle font-light text-xs text-gray-500 text-wrap break-words max-sm:flex-row max-sm:justify-center max-sm:align-middle" }
const _hoisted_12 = { class: "text-black-700" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "p-4" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "font-normal text-gray-700" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flex flex-row ml-auto items-center justify-end mt-3 gap-1" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 text-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg" }, "Image.jpg"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2 text-gray-500 text-sm mt-1" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "font-normal" }, "20/10/1500"),
    /*#__PURE__*/_createElementVNode("p", null, "46.mb")
  ])
], -1)
const _hoisted_22 = { class: "flex items-center justify-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 text-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg" }, "Image.jpg"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2 text-gray-500 text-sm mt-1" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "font-normal" }, "20/10/1500"),
    /*#__PURE__*/_createElementVNode("p", null, "46.mb")
  ])
], -1)
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 text-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg" }, "Image.jpg"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2 text-gray-500 text-sm mt-1" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "font-normal" }, "20/10/1500"),
    /*#__PURE__*/_createElementVNode("p", null, "46.mb")
  ])
], -1)

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { CircleCheck, ClipboardList, Download, LoaderCircle, Redo2 } from 'lucide-vue-next';
import { ref, computed, watch, onMounted } from 'vue';
import { TagsInput, TagsInputInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText } from '@/components/ui/tags-input';
import { Textarea } from '@/components/ui/textarea';
import CustomerFieldSection from './CustomerFieldSection.vue';
import { Customer, CustomerSession, queryForSessionsOfCustomerKey } from '@/http/customerSession';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import PartnerAttributes from '@/components/converza-sessions/chat/PartnerAttributes.vue';
import store, { GET_SESSIONS, PATCH_CUSTOMER_FIELD } from '@/store';
import { set } from '@vueuse/core';
import Button from '@/components/ui/button/Button.vue';

const HAS_ANNEXES_FEATURE = false;
const HAS_HISTORY = true;
const HAS_TAG_FEATURE = false;

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatCustomerSidebar',
  props: {
    customerSessionId: {
        type: String,
        required: true,
    }
},
  emits: ['updated-customer-name'],
  setup(__props) {



const { state, getters } = useStore();
const updatedCustomerName = ref<string | undefined>(undefined);

const props = __props;

const getCustomerSession = (): CustomerSession => getters[GET_SESSIONS][props.customerSessionId];
const customerSession = computed<CustomerSession>(getCustomerSession);
const customer = computed<Customer | undefined>(() => customerSession.value?.customer);
const customerId = computed<string | undefined>(() => customer.value?.id);
const customerSessions = ref<Map<string, CustomerSession>>(new Map<string, CustomerSession>);

const tags = ref([]);

const router = useRouter();
const routeToOldSession = async (oldSessionId: string) => {
    await router.push({ path: `/dashboard/atendimento/${oldSessionId}` });
};

const queryForOldSessions = async (customerKey: string) => {
    const credentials = state.credentials;
    if (credentials === undefined)
        throw new Error("Credentials are not present");
    const oldSesionsPage = await queryForSessionsOfCustomerKey(customerKey, credentials);
    const oldSessions = oldSesionsPage.content.filter(session => session.id !== customerSession.value?.id);
    customerSessions.value = new Map<string, CustomerSession>();
    oldSessions.forEach(session => customerSessions.value.set(session.id, session));
};

const providerPresentationName = ref();

watch(customerSession, async (newCustomerSession, oldCustomerSession) => {
    if (newCustomerSession?.id !== oldCustomerSession?.id) {
        resetNotes();
    }
    const providerPresentationNameInStore = state.partnerProviders[newCustomerSession?.partnerProviderId ?? '']?.presentationNameInProvider;
    if (providerPresentationNameInStore == undefined) { return; }
    set(providerPresentationName, providerPresentationNameInStore);
});

const notes = ref<string | undefined>();
const resetNotes = () => {
    const hisNotes = getCustomerSession()?.customer?.notes;
    set(notes, hisNotes);
};
onMounted(resetNotes);

const shouldShowProgressOnNotes = ref(false);
const shouldShowEndedOnNotes = ref(false);

const saveNotes = async () => {
    if (customer.value === undefined) return;
    if (notes.value === undefined) return;
    if (shouldShowProgressOnNotes.value === true || shouldShowEndedOnNotes.value === true) return;

    const payload = {
        partnerId: customer.value.associatedPartnerId,
        customerKey: customer.value.key,
        notes: notes.value,
    };

    shouldShowProgressOnNotes.value = true;
    await store.dispatch(PATCH_CUSTOMER_FIELD, payload);
    setTimeout(() => {
        shouldShowProgressOnNotes.value = false;
        shouldShowEndedOnNotes.value = true;
        setTimeout(() => {
            shouldShowEndedOnNotes.value = false;
        }, 1000);
    }, 300);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Avatar), { size: "md" }, {
          default: _withCtx(() => [
            _createVNode(_unref(AvatarImage), {
              src: "https://github.com/radix-vue.png",
              alt: "@radix-vue"
            }),
            _createVNode(_unref(AvatarFallback), null, {
              default: _withCtx(() => [
                _createTextVNode("CN")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (customerId.value !== undefined)
        ? (_openBlock(), _createBlock(PartnerAttributes, {
            key: 0,
            class: "col-span-1",
            customerId: customerId.value,
            onUpdatedCustomerName: _cache[0] || (_cache[0] = (newName) => {
                    if (customer.value === undefined) return;
                    customer.value.partnerAttributes ??= {};
                    customer.value.partnerAttributes.name = newName;
                    _ctx.$emit('updated-customer-name', newName);
                })
          }, null, 8, ["customerId"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(updatedCustomerName.value ?? customer.value?.partnerAttributes.name ??
                    customer.value?.key ?? ''), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full max-sm:ml-7 max-md:align-middle", { hidden: !customerSession.value?.whoIsChatting }])
          }, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(customerSession.value?.nameOfWhoIsChatting ?? customerSession.value?.whoIsChatting), 1)
          ], 2),
          (providerPresentationName.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createTextVNode(" Vindo de: "),
                  _createElementVNode("strong", _hoisted_12, _toDisplayString(providerPresentationName.value), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      HAS_HISTORY
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(CustomerFieldSection, {
              modelValue: customerSession.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerSession).value = $event)),
              title: "Histórico Cliente",
              "action-when-show": async () => {
                        if (!customer.value?.key)
                            return;
                        queryForOldSessions(customer.value?.key);
                    },
              hasToShowOnStart: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerSessions.value, ([id, session]) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "text-sm font-semibold cursor-pointer",
                      key: id,
                      onClick: async () => await routeToOldSession(id)
                    }, [
                      _createTextVNode(" Protocolo: "),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(session.protocol), 1)
                    ], 8, _hoisted_15))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "action-when-show"])
          ]))
        : _createCommentVNode("", true),
      HAS_TAG_FEATURE
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(CustomerFieldSection, {
              title: "Tags",
              modelValue: customerSession.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerSession).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TagsInput), {
                  modelValue: tags.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tags).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (item) => {
                      return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                        key: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TagsInputItemText)),
                          _createVNode(_unref(TagsInputItemDelete))
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128)),
                    _createVNode(_unref(TagsInputInput), { placeholder: "Adicione uma tag" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(CustomerFieldSection, {
          modelValue: customerSession.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customerSession).value = $event)),
          title: "Observações"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Textarea), {
              name: "notes",
              spellcheck: "false",
              placeholder: "Adicione uma observação",
              modelValue: notes.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((notes).value = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(Button, {
                variant: "ghost",
                size: "icon",
                onClick: _cache[5] || (_cache[5] = () => notes.value = customer.value?.notes)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Redo2), { class: "text-slate-400" })
                ]),
                _: 1
              }),
              _createVNode(Button, {
                variant: "default",
                size: "icon",
                onClick: saveNotes,
                class: _normalizeClass({
                                'bg-green-500': shouldShowEndedOnNotes.value
                            })
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_unref(LoaderCircle), { class: "animate-spin" }, null, 512), [
                    [_vShow, shouldShowProgressOnNotes.value]
                  ]),
                  _withDirectives(_createVNode(_unref(CircleCheck), null, null, 512), [
                    [_vShow, !shouldShowProgressOnNotes.value]
                  ])
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      HAS_ANNEXES_FEATURE
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(CustomerFieldSection, {
              title: "Arquivos Anexo",
              modelValue: customerSession.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customerSession).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ScrollArea), { class: "h-35 w-full overflow-y-auto" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_unref(ClipboardList), { class: "mr-2" }),
                      _hoisted_21,
                      _createVNode(_unref(Download), { class: "ml-2" })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_unref(ClipboardList), { class: "mr-2" }),
                      _hoisted_23,
                      _createVNode(_unref(Download), { class: "ml-2" })
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_unref(ClipboardList), { class: "mr-2" }),
                      _hoisted_25,
                      _createVNode(_unref(Download), { class: "ml-2" })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})